import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Form as BootstrapForm, Row, Col, Button } from 'react-bootstrap'
import { useFormik } from "formik";
import {obtenerTiposEventoAction,  registrarBitacoraAction} from "../../store/actions/bitacora-action";
import {LoadingComponent} from "recupero-comunes";
import "recupero-comunes/dist/index.css";
import { validationSchemaForm } from "../../utils/validation";
import Destinatarios from './destinatarios';
import { serviceGetDestinatarios } from '../../api/bitacora-client';

const IngresoEventos = ({ rutcia, idCaso, user }) => {
 
  const [loading, setLoading] = useState(false);
  const [tiposEventoFiltrados, setTiposEventoFiltrados] = useState([]);

  // El hook useSelector (redux) permite acceder al state en nuestro store.
  const data_bitacora = useSelector((state) => state.bitacora);
  const { cfg_form, tiposEvento } = data_bitacora;

  // El hook useDispatch (redux) permite invocar una action.
  const dispatch = useDispatch();
  
  const[chkNotifica, setChkNotifica]=useState(0)
  const [destinatarios, setDestinatarios] = useState([]);
  const[tipoEventoDefault, setTipoEventoDefault]=useState([])

  useEffect(() => {
    // @TODO: reemplazar valor estáticos.
    let query = Buffer.from(
      JSON.stringify({ rutcia: rutcia, concepto: 222 })
    ).toString("base64");
    dispatch(obtenerTiposEventoAction(query));
  }, [dispatch]);

  useEffect(() => {
    if (tiposEvento) {
      let tiposEventoFiltrados = [];
      tiposEvento.forEach((tipoEvento) => {
        if (tipoEvento.agrupacion == 221010) {
          tiposEventoFiltrados.push(tipoEvento);
        }
      });
      setTiposEventoFiltrados(tiposEventoFiltrados);     
      if (tiposEventoFiltrados && tiposEventoFiltrados.length == 1) {
        setTipoEventoDefault(tiposEventoFiltrados);
      }
    }
  }, [tiposEvento]);
  
  const handleChkNotifica = async (checked) => {
    setChkNotifica(checked);
    if (checked) {
      getDestinatarios();
    }
  }  
  const getDestinatarios = async () => {        
    setLoading(true);
    let query = Buffer.from(JSON.stringify({ idCaso: idCaso})).toString('base64');
    const response = await serviceGetDestinatarios(query);

    setDestinatarios(response);
    setLoading(false);
  }
  const formik = useFormik({
    initialValues:{
      idCaso: idCaso,
      tipoEvento: "",
      instanciaEvento: "",
      fechaOcurrencia: "",
      minuta: "",
      idUsrIngreso: user,
    },
    validationSchema: validationSchemaForm,
    onSubmit: (formData, formikHelpers) => {
      
      formData.instanciaEvento = tiposEventoFiltrados.find((item) => item.id === formData.tipoEvento)?.agrupacion;
      formData.destinatarios = destinatarios;

      setLoading(true);
      dispatch(registrarBitacoraAction(formData))
        .then(() => {
          setLoading(false);
          alert("Bitácora registrada correctamente.");
          handleReset();
        })
        .catch((error) => {
          setLoading(false);
          alert(error.message);
        });
    }
  });
  const handleReset = () => {
    setDestinatarios([]);
    setChkNotifica(0);
    formik.resetForm();
  }
  return (
    <div>
      <LoadingComponent show={loading} />
      {cfg_form ? (
        <div>
          <BootstrapForm onSubmit={formik.handleSubmit}>
            <Row>
              <Col md='3'>
                  <BootstrapForm.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '16px' }}>
                      {cfg_form && cfg_form["bitacora-cmb-tipoevento"]}
                  </BootstrapForm.Label>
                  <BootstrapForm.Select
                      name='tipoEvento'
                      value={formik.values.tipoEvento = tipoEventoDefault[0]?.id}
                      onChange={(e) => formik.handleChange(e)}
                      onBlur={formik.handleBlur}>

                      <option value={''}>Seleccione...</option>
                      {tiposEventoFiltrados
                          .map((c) => (
                          <option key={c.id} value={c.id}>{c.nombre}</option>
                      ))}
                  </BootstrapForm.Select>
                  {formik.errors.tipoEvento && formik.touched.tipoEvento &&
                      <BootstrapForm.Text variant='danger' style={{ color: 'red' }}>
                          {formik.errors.tipoEvento}
                      </BootstrapForm.Text>
                  }
              </Col>
              <Col md='1'></Col>
              <Col md='3'>
                  <BootstrapForm.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '16px' }}>
                      {cfg_form && cfg_form["bitacora-inp-fechaocurrencia"]}
                  </BootstrapForm.Label>
                  <BootstrapForm.Control
                      type='date'
                      name='fechaOcurrencia'
                      value={formik.values.fechaOcurrencia}
                      onChange={(e) => formik.handleChange(e)}
                      onBlur={formik.handleBlur}
                  ></BootstrapForm.Control>
                  {formik.errors.fechaOcurrencia && formik.touched.fechaOcurrencia &&
                      <BootstrapForm.Text variant='danger' style={{ color: 'red' }}>
                          {formik.errors.fechaOcurrencia}
                      </BootstrapForm.Text>
                  }
              </Col>
              <Col md='1'></Col>
              <Col md="4">
                  <BootstrapForm.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '16px' }}>
                      { }
                    </BootstrapForm.Label>
                    <br />
                  <BootstrapForm.Check 
                      type="checkbox" 
                      checked={chkNotifica} 
                      name="chkNotifica" 
                      id="chkNotifica" 
                      label="Notifica Evento"
                      onChange={e=>{
                          handleChkNotifica(e.target.checked)                                                              
                      }}/>
                </Col>
            </Row>
            <Row className="mt-4">
                <Col md='12'>
                  <BootstrapForm.Label className='mb-0 mt-3' style={{fontWeight: 'bold', fontSize: '16px'}}>
                      {cfg_form['bitacora-inp-observaciones']} 
                  </BootstrapForm.Label>
                  <br/>
                  <BootstrapForm.Control
                      as='textarea'
                      className='mt-2 mb-1'
                      rows={3}
                      onChange={(e) => {
                          formik.handleChange(e)
                      }}
                      name='minuta'
                      value={(formik.values.minuta)}
                      error={formik.errors.minuta}
                      />
                      {formik.errors.minuta ? (
                      <BootstrapForm.Text variant='danger' style={{ color: 'red' }}>
                          {formik.errors.minuta}
                      </BootstrapForm.Text>
                      ) : (
                      ''
                      )}
                  </Col>
              </Row>
              <Row className="mt-4">
                <Col md="10"></Col>
                <Col md="2">
                  <Button className="btn btn-danger" type="submit">
                    {cfg_form["bitacora-boton-registrar"]}
                  </Button>
                </Col>
              </Row>
          </BootstrapForm>
          
          { chkNotifica ? (
            <Destinatarios
              cfg_form={cfg_form} 
              idCaso={idCaso} 
              idImplicado={0}
              destinatarios={destinatarios}
              setDestinatarios={setDestinatarios}
            />
          ) : null}        
        </div>
      ) : null}
    </div>
  );
};
export default IngresoEventos;
